
import { ChallengeData } from "@/utils/i18n/types";

export const staticChallenges: ChallengeData[] = [{
  id: "lamour-surcote",
  title: "L'amour c'est surcoté",
  description: "Participez au challenge créatif",
  thumbnail: "/lovable-uploads/a0f0939a-3b33-4cf7-8f8d-85504e9ad117.png",
  start_date: "2024-05-01T00:00:00",
  end_date: "2025-04-20T23:59:59",
  status: "completed"
}];

export const fetchChallenges = async (): Promise<ChallengeData[]> => {
  return staticChallenges;
};

